import { MINI_MENU_LINKS } from '../links';

const {
  MY_ACCOUNT_DETAILS,
  MY_GIFT,
  MY_VOUCHERS,
  BECOME_MERCHANT,
  WALLET,
  RAF,
  NEED_HELP,
} = MINI_MENU_LINKS;

export const MINI_MENU = [
  { name: 'My Vouchers', value: MY_VOUCHERS },
  { name: 'View Account Details', value: MY_ACCOUNT_DETAILS },
  // { name: 'Claim credit', value: MINI_MENU_CREDIT },
  { name: 'My Wallet', value: WALLET },
  // { name: 'Club Wowcher', value: MINI_MENU_REWARDS },
  // { name: 'Redeem a gift card', value: MINI_MENU_REDEEM },
  { name: 'Claim a gift', value: MY_GIFT },
  { name: 'Become a merchant', value: BECOME_MERCHANT },
];
const RAF_MENU = { name: 'Refer a friend', value: RAF };

// LAYOUTS
export const MY_ACCOUNT_LAYOUT = {
  accountOptionsHi: (value) => `Hi ${value}`,
  accountOptionsLower: [
    {
      name: 'Need help?',
      value: NEED_HELP,
    },
  ],
  miniMenu: MINI_MENU,
  rafMenu: RAF_MENU,
  viewHistory: 'View history',
  viewYourVouchers: 'View your Vouchers',
  voucherStatusList: [
    {
      desc: 'Print this voucher and use it to redeem your deal!',
      title: 'Ready to Redeem',
    },
    {
      desc: 'The voucher has been redeemed',
      title: 'Redeemed',
    },
    {
      desc: 'Expect travel documentation from Merchant within 3 working days from booking',
      title: 'Booked',
    },
    {
      desc: 'A credit has been requested',
      title: 'Credit Requested',
    },
    {
      desc: 'Redeemed for credit or towards another deal',
      title: 'Request Processed',
    },
    {
      desc: 'A return has been requested',
      title: 'Return Requested',
    },
    {
      desc: 'The item is on the way back to the merchant',
      title: 'Return in Transit',
    },
    {
      desc: 'The item has been returned to the merchant',
      title: 'Returned to the Merchant',
    },
    {
      desc: 'The voucher has been refunded',
      title: 'Refunded',
    },
    {
      desc: 'The voucher expiry date has passed',
      title: 'Expired',
    },
  ],
  voucherStatusTitle: 'Voucher Status',
};

// Hyperlocal SEO
export const HYPER_LOCAL_SEO_META_TITLE = (seoFriendlyName) =>
  `${seoFriendlyName} - Deals of up to 80% off`;
export const HYPER_LOCATION_META_TITLE = (area) =>
  `${area} Deals - Restaurants, Spas, Things to do  - Wowcher`;
export const HYPER_LOCATION_META_DESCRIPTION = (area) =>
  `Check out our deals and offers for things to do in ${area}! From the best places to eat to thrilling activities for the whole family, ${area} is a great place to spend the day or even a relaxing week and with these deals you can experience the best it has to offer!`;
